/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbApprenantDoublonGridDto } from './FcbApprenantDoublonGridDto';
import {
    FcbApprenantDoublonGridDtoFromJSON,
    FcbApprenantDoublonGridDtoFromJSONTyped,
    FcbApprenantDoublonGridDtoToJSON,
} from './FcbApprenantDoublonGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbApprenantDoublonGridDtoPaginatedResults
 */
export interface FcbApprenantDoublonGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbApprenantDoublonGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbApprenantDoublonGridDto>}
     * @memberof FcbApprenantDoublonGridDtoPaginatedResults
     */
    results?: Array<FcbApprenantDoublonGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbApprenantDoublonGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbApprenantDoublonGridDtoPaginatedResults interface.
 */
export function instanceOfFcbApprenantDoublonGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbApprenantDoublonGridDtoPaginatedResultsFromJSON(json: any): FcbApprenantDoublonGridDtoPaginatedResults {
    return FcbApprenantDoublonGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbApprenantDoublonGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbApprenantDoublonGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbApprenantDoublonGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbApprenantDoublonGridDtoPaginatedResultsToJSON(value?: FcbApprenantDoublonGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbApprenantDoublonGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

